import { Paragraphs } from '../types/global';
import { useMemo } from 'react';
import slugify from '../utils/slugify';

export interface TableOfContentLink {
  title: string;
  anchor: string;
}
export type TableOfContentLinks = Array<TableOfContentLink>;

export default function useTableOfContentLinks(
  paragraphs: Paragraphs
): TableOfContentLinks {
  return useMemo(() => {
    return (
      paragraphs
        // @note: We use any type here because paragraph could be just empty
        .map((paragraph: any) => {
          if (
            paragraph.__typename === 'ParagraphText' &&
            paragraph.addToTableOfContents &&
            paragraph.headline
          ) {
            return {
              title: paragraph.headline,
              anchor: slugify(paragraph.headline) || '',
            };
          } else if (
            (paragraph.__typename === 'ParagraphTextWithImage' ||
              paragraph.__typename === 'ParagraphInfoBox') &&
            paragraph.textParagraph.addToTableOfContents &&
            paragraph.textParagraph.headline
          ) {
            return {
              title: paragraph.textParagraph.headline,
              anchor: slugify(paragraph.textParagraph.headline),
            };
          }

          return null;
        })
        .filter(Boolean) as TableOfContentLinks
    );
  }, [paragraphs]);
}
